import type { Car } from '@ahd/shared/types/ahd-cars/car/car';
import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntAufbau: SelectDataObject<{ ika?: Car['ika'] }>[] = [
    { i: 0, t: '(unbekannt)', hidden: true },
    { i: 1010, t: 'andere', ika: 10 },
    { i: 1009, t: 'Avant/Variant/Kombi', ika: 10 },
    { i: 1008, t: 'Limousine', ika: 10 },
    { i: 1007, t: 'Van/Kleinbus', ika: 10 },
    { i: 1006, t: 'Geländewagen / SUV', ika: 10 },
    { i: 1005, t: 'Coupé', ika: 10 },
    { i: 1004, t: 'Roadster', ika: 10 },
    { i: 1003, t: 'Cabriolet', ika: 10 },
    { i: 1002, t: 'Sportwagen', ika: 10 },
    { i: 1001, t: 'Pickup', ika: 10 },
    { i: 1000, t: 'Kleinwagen', ika: 10 },
    { i: 4904, t: 'Volumen-SZM', ika: 100 },
    { i: 4903, t: 'Standard-SZM', ika: 100 },
    { i: 4902, t: 'Schwerlast', ika: 100 },
    { i: 4901, t: 'Gefahrgut', ika: 100 },
    { i: 4900, t: 'andere', ika: 100 },
    { i: 4412, t: 'Plattform Auflieger', ika: 101 },
    { i: 4422, t: 'Wechselfahrgestell Auflieger', ika: 101 },
    { i: 4421, t: 'Walkingfloor Auflieger', ika: 101 },
    { i: 4420, t: 'Viehtransporter Auflieger', ika: 101 },
    { i: 4419, t: 'Verkaufsaufbau Auflieger', ika: 101 },
    { i: 4418, t: 'Tieflader Auflieger', ika: 101 },
    { i: 4417, t: 'Tiefkühl Auflieger', ika: 101 },
    { i: 4416, t: 'Tankaufbau Auflieger', ika: 101 },
    { i: 4415, t: 'Silo Auflieger', ika: 101 },
    { i: 4414, t: 'Pritsche + Plane Auflieger', ika: 101 },
    { i: 4413, t: 'Pritsche Auflieger', ika: 101 },
    { i: 4411, t: 'Lebensmitteltank Auflieger', ika: 101 },
    { i: 4410, t: 'Langmaterialtransporter Auflieger', ika: 101 },
    { i: 4409, t: 'Kühlkoffer Auflieger', ika: 101 },
    { i: 4408, t: 'Koffer Auflieger', ika: 101 },
    { i: 4407, t: 'Kipper Auflieger', ika: 101 },
    { i: 4405, t: 'Holztransporter Auflieger', ika: 101 },
    { i: 4403, t: 'Fahrgestell Auflieger', ika: 101 },
    { i: 4402, t: 'Autotransporter Auflieger', ika: 101 },
    { i: 4401, t: 'Autokran Auflieger', ika: 101 },
    { i: 4400, t: 'andere', ika: 101 },
    { i: 4404, t: 'Getränke Auflieger', ika: 101 },
    { i: 4304, t: 'Getränke', ika: 70 },
    { i: 4335, t: 'Fahrgestell Anhänger', ika: 70 },
    { i: 4334, t: 'Bootsanhänger', ika: 70 },
    { i: 4333, t: 'Bauwagen', ika: 70 },
    { i: 4332, t: 'Motorradanhänger', ika: 70 },
    { i: 4331, t: 'Pritsche + Plane', ika: 70 },
    { i: 4330, t: 'Pritsche', ika: 70 },
    { i: 4325, t: 'andere', ika: 70 },
    { i: 4324, t: 'Wechselpritsche', ika: 70 },
    { i: 4323, t: 'Wechselfahrgestell', ika: 70 },
    { i: 4322, t: 'Walkingfloor', ika: 70 },
    { i: 4321, t: 'Verkehrsaufbau Hänger', ika: 70 },
    { i: 4320, t: 'Tier-/Pferdetransport', ika: 70 },
    { i: 4319, t: 'Tieflader', ika: 70 },
    { i: 4318, t: 'Tankaufbau', ika: 70 },
    { i: 4317, t: 'Silo', ika: 70 },
    { i: 4314, t: 'Plattform', ika: 70 },
    { i: 4313, t: 'Pkw-Anhänger', ika: 70 },
    { i: 4312, t: 'Möbellift', ika: 70 },
    { i: 4311, t: 'Lebensmitteltank', ika: 70 },
    { i: 4310, t: 'Langmaterialtransporter', ika: 70 },
    { i: 4309, t: 'Kühlkoffer', ika: 70 },
    { i: 4308, t: 'Koffer', ika: 70 },
    { i: 4307, t: 'Hubarbeitsbühne', ika: 70 },
    { i: 4306, t: 'Holztransporter', ika: 70 },
    { i: 4305, t: 'Glastransport', ika: 70 },
    { i: 4302, t: 'Dreiseitenkipper', ika: 70 },
    { i: 4301, t: 'Autotransporter', ika: 70 },
    { i: 4300, t: 'Abrollanhänger', ika: 70 },
    { i: 4615, t: 'Baugeräte', ika: 102 },
    { i: 4614, t: 'Baggerlader', ika: 102 },
    { i: 4612, t: 'Verdichtungstechnik', ika: 102 },
    { i: 4611, t: 'Mobilbagger', ika: 102 },
    { i: 4610, t: 'Kran, stationär', ika: 102 },
    { i: 4609, t: 'Kettenbagger', ika: 102 },
    { i: 4608, t: 'Grader', ika: 102 },
    { i: 4607, t: 'Bohrgerät', ika: 102 },
    { i: 4606, t: 'Bodenstabilisierer', ika: 102 },
    { i: 4603, t: 'Raupe/Dozer', ika: 102 },
    { i: 4602, t: 'Mini-/Kompaktbagger', ika: 102 },
    { i: 4601, t: 'Radlader', ika: 102 },
    { i: 4600, t: 'andere', ika: 102 },
    { i: 4604, t: 'Arbeitsbühne', ika: 102 },
    { i: 4605, t: 'Asphalttechnik', ika: 102 },
    { i: 4613, t: 'Walzen', ika: 102 },
    { i: 4103, t: 'Linienbus', ika: 103 },
    { i: 4104, t: 'Reisebus', ika: 103 },
    { i: 4105, t: 'Überlandbus', ika: 103 },
    { i: 4107, t: 'Kleinbus', ika: 103 },
    { i: 4106, t: 'andere', ika: 103 },
    { i: 4101, t: 'Gelenkbus', ika: 103 },
    { i: 4100, t: 'Doppeldecker', ika: 103 },
    { i: 4517, t: 'Transportfahrzeug', ika: 104 },
    { i: 4516, t: 'sonstige Anbauten', ika: 104 },
    { i: 4515, t: 'Schlepper', ika: 104 },
    { i: 4514, t: 'Pflug', ika: 104 },
    { i: 4513, t: 'Pflanzenschutz', ika: 104 },
    { i: 4512, t: 'Obstbau', ika: 104 },
    { i: 4511, t: 'Mulcher', ika: 104 },
    { i: 4510, t: 'Mäher', ika: 104 },
    { i: 4509, t: 'Mähdrescher', ika: 104 },
    { i: 4508, t: 'Hofschlepper', ika: 104 },
    { i: 4507, t: 'Heumaschine', ika: 104 },
    { i: 4506, t: 'Frontlader', ika: 104 },
    { i: 4505, t: 'Forst', ika: 104 },
    { i: 4504, t: 'Erntemaschine', ika: 104 },
    { i: 4503, t: 'Düngerstreuer', ika: 104 },
    { i: 4502, t: 'Drillmaschine', ika: 104 },
    { i: 4501, t: 'Bodenbearbeitung', ika: 104 },
    { i: 4500, t: 'andere', ika: 104 },
    { i: 4303, t: 'Fahrgestell über 7,5t', ika: 40 },
    { i: 4327, t: 'Dreiseitenkipper über 7,5t', ika: 40 },
    { i: 4316, t: 'Pritsche + Plane über 7,5t', ika: 40 },
    { i: 4315, t: 'Pritsche über 7,5t', ika: 40 },
    { i: 4827, t: 'Jumbo-Lkw über 7,5t', ika: 40 },
    { i: 4826, t: 'Betonpumpe über 7,5t', ika: 40 },
    { i: 4825, t: 'Verkaufsaufbau über 7,5t', ika: 40 },
    { i: 4824, t: 'Tier-/Pferdetransportwagen über 7,5t', ika: 40 },
    { i: 4823, t: 'Saug- und Druckwagen über 7,5t', ika: 40 },
    { i: 4821, t: 'Müllwagen über 7,5t', ika: 40 },
    { i: 4820, t: 'Muldenkipper über 7,5t', ika: 40 },
    { i: 4819, t: 'Lebensmitteltankwagen über 7,5t', ika: 40 },
    { i: 4818, t: 'Koffer über 7,5t', ika: 40 },
    { i: 4817, t: 'Kehrmaschine über 7,5t', ika: 40 },
    { i: 4816, t: 'Hubarbeitsbühne über 7,5t', ika: 40 },
    { i: 4815, t: 'Holztransporter über 7,5t', ika: 40 },
    { i: 4814, t: 'Getreidekipper über 7,5t', ika: 40 },
    { i: 4813, t: 'Getränkewagen über 7,5t', ika: 40 },
    { i: 4811, t: 'andere', ika: 40 },
    { i: 4810, t: 'Absetzkipper über 7,5t', ika: 40 },
    { i: 4809, t: 'Abschleppwagen über 7,5t', ika: 40 },
    { i: 4808, t: 'Betonmischer über 7,5t', ika: 40 },
    { i: 4807, t: 'Wechselfahrgestell über 7,5t', ika: 40 },
    { i: 4806, t: 'Abrollkipper über 7,5t', ika: 40 },
    { i: 4805, t: 'Tankwagen über 7,5t', ika: 40 },
    { i: 4804, t: 'Autokran über 7,5t', ika: 40 },
    { i: 4803, t: 'Kühlkoffer über 7,5t', ika: 40 },
    { i: 4801, t: 'Kipper über 7,5t', ika: 40 },
    { i: 4800, t: 'Autotransporter über 7,5t', ika: 40 },
    { i: 4204, t: 'Hochregalstapler', ika: 105 },
    { i: 4205, t: 'Niederhubwagen', ika: 105 },
    { i: 4206, t: 'Schubmaststapler', ika: 105 },
    { i: 4207, t: 'Seitenstapler', ika: 105 },
    { i: 4208, t: 'Teleskoparmstapler', ika: 105 },
    { i: 4209, t: 'andere', ika: 105 },
    { i: 4203, t: 'Hochhubwagen', ika: 105 },
    { i: 4202, t: 'Geländestapler', ika: 105 },
    { i: 4201, t: 'Frontstapler', ika: 105 },
    { i: 4200, t: 'Containerstapler', ika: 105 },
    { i: 4722, t: 'Müllwagen unter 7,5t', ika: 80 },
    { i: 4721, t: 'Rettungswagen unter 7,5t', ika: 80 },
    { i: 4720, t: 'Getränke unter 7,5t', ika: 80 },
    { i: 4719, t: 'Tier-/Pferdetransport unter 7,5t', ika: 80 },
    { i: 4718, t: 'Fahrgestell unter 7,5t', ika: 80 },
    { i: 4717, t: 'Absetzkipper unter 7,5t', ika: 80 },
    { i: 4716, t: 'Kipper unter 7,5t', ika: 80 },
    { i: 4715, t: 'Wechselfahrgestell unter 7,5t', ika: 80 },
    { i: 4714, t: 'Verkaufsaufbau unter 7,5t', ika: 80 },
    { i: 4713, t: 'Tier-/Pferdetransportwagen unter 7,5t', ika: 80 },
    { i: 4712, t: 'Tankaufbau unter 7,5t', ika: 80 },
    { i: 4711, t: 'Saug- und Druckwagen unter 7,5t', ika: 80 },
    { i: 4710, t: 'Pritsche unter 7,5t', ika: 80 },
    { i: 4708, t: 'Kombi, Kleinbus bis 9 Sitze unter 7,5t', ika: 80 },
    { i: 4707, t: 'Kehrmaschine unter 7,5t', ika: 80 },
    { i: 4706, t: 'Hubarbeitsbühne unter 7,5t', ika: 80 },
    { i: 4705, t: 'Glastransporter unter 7,5t', ika: 80 },
    { i: 4704, t: 'Geldtransporter unter 7,5t', ika: 80 },
    { i: 4703, t: 'Autotransporter unter 7,5t', ika: 80 },
    { i: 4702, t: 'Autokran unter 7,5t', ika: 80 },
    { i: 4701, t: 'Abrollkipper unter 7,5t', ika: 80 },
    { i: 3019, t: 'Kühlkoffer unter 7,5t', ika: 80 },
    { i: 3011, t: 'Abschleppwagen unter 7,5t', ika: 80 },
    { i: 3010, t: 'Koffer unter 7,5t', ika: 80 },
    { i: 3004, t: 'Kasten unter 7,5t', ika: 80 },
    { i: 3003, t: 'Pritsche + Plane unter 7,5t', ika: 80 },
    { i: 3002, t: 'Kastenwagen hoch + lang unter 7,5t', ika: 80 },
    { i: 3001, t: 'Kastenwagen hoch unter 7,5t', ika: 80 },
    { i: 3000, t: 'Kastenwagen lang unter 7,5t', ika: 80 },
    { i: 4423, t: 'Kühlkastenwagen unter 7,5t', ika: 80 },
    { i: 4326, t: 'Dreiseitenkipper unter 7,5t', ika: 80 },
    { i: 8000, t: 'andere', ika: 80 },
    { i: 5101, t: 'Campingfahrzeug', ika: 51 },
    { i: 5100, t: 'andere', ika: 51 },
    { i: 5007, t: 'Mobilheim', ika: 51 },
    { i: 5006, t: 'Wohnmobil Pickup', ika: 51 },
    { i: 5005, t: 'Wohnkabine', ika: 51 },
    { i: 5004, t: 'Kastenwagen', ika: 51 },
    { i: 5003, t: 'Teilintegrierter', ika: 51 },
    { i: 5002, t: 'Integrierter', ika: 51 },
    { i: 5001, t: 'Alkoven', ika: 51 },
    { i: 5201, t: 'Wohnwagen', ika: 52 },
    { i: 5200, t: 'andere', ika: 52 },
    { i: 6007, t: 'Rennsport', ika: 60 },
    { i: 6001, t: 'Enduro/Reiseenduro', ika: 60 },
    { i: 6004, t: 'Mofa/Mokick/Moped', ika: 60 },
    { i: 6005, t: 'Motorrad', ika: 60 },
    { i: 6008, t: 'Roller/Scooter', ika: 60 },
    { i: 6009, t: 'Sportler/Supersportler', ika: 60 },
    { i: 6010, t: 'Streetfighter', ika: 60 },
    { i: 6011, t: 'Tourer', ika: 60 },
    { i: 6012, t: 'Trike', ika: 60 },
    { i: 6013, t: 'andere', ika: 60 },
    { i: 6014, t: 'Quad', ika: 60 },
    { i: 6015, t: 'Dirt Bike', ika: 60 },
    { i: 6016, t: 'Naked Bike', ika: 60 },
    { i: 6017, t: 'Pocket Bike', ika: 60 },
    { i: 6019, t: 'Super Moto', ika: 60 },
    { i: 6018, t: 'Sporttourer', ika: 60 },
    { i: 6006, t: 'Rallye/Cross', ika: 60 },
    { i: 6000, t: 'Chopper/Cruiser', ika: 60 },
    { i: 6002, t: 'Gespann/Seitenwagen', ika: 60 },
    { i: 6003, t: 'Klein/Leichtkraftrad', ika: 60 },
];
export default sIntAufbau;
